import { render, staticRenderFns } from "./ShippingHistory.vue?vue&type=template&id=1851f793"
import script from "./ShippingHistory.vue?vue&type=script&lang=js"
export * from "./ShippingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports